import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Condolence\SendCondoleanceController::__invoke
* @see app/Http/Controllers/Condolence/SendCondoleanceController.php
* @route '/api/condolence/{condolence}/send'
*/
const SendCondoleanceController = (args: { condolence: string | number | { id: string | number } } | [condolence: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: SendCondoleanceController.url(args, options),
    method: 'get',
})

SendCondoleanceController.definition = {
    methods: ["get","head"],
    url: '/api/condolence/{condolence}/send',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Condolence\SendCondoleanceController::__invoke
* @see app/Http/Controllers/Condolence/SendCondoleanceController.php
* @route '/api/condolence/{condolence}/send'
*/
SendCondoleanceController.url = (args: { condolence: string | number | { id: string | number } } | [condolence: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { condolence: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { condolence: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            condolence: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        condolence: typeof args.condolence === 'object'
        ? args.condolence.id
        : args.condolence,
    }

    return SendCondoleanceController.definition.url
            .replace('{condolence}', parsedArgs.condolence.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Condolence\SendCondoleanceController::__invoke
* @see app/Http/Controllers/Condolence/SendCondoleanceController.php
* @route '/api/condolence/{condolence}/send'
*/
SendCondoleanceController.get = (args: { condolence: string | number | { id: string | number } } | [condolence: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: SendCondoleanceController.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Condolence\SendCondoleanceController::__invoke
* @see app/Http/Controllers/Condolence/SendCondoleanceController.php
* @route '/api/condolence/{condolence}/send'
*/
SendCondoleanceController.head = (args: { condolence: string | number | { id: string | number } } | [condolence: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: SendCondoleanceController.url(args, options),
    method: 'head',
})

export default SendCondoleanceController